/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as SignInRouteImport } from "./routes/sign-in";
import { Route as AppIndexRouteImport } from "./routes/_app.index";
import { Route as AppCatalogRouteImport } from "./routes/_app.catalog";
import { Route as AppClientsRouteImport } from "./routes/_app.clients";
import { Route as AppGrowthRouteImport } from "./routes/_app.growth";
import { Route as AppMoneyRouteImport } from "./routes/_app.money";
import { Route as AppNowRouteImport } from "./routes/_app.now";
import { Route as AppOrdersRouteImport } from "./routes/_app.orders";
import { Route as AppSettingsRouteImport } from "./routes/_app.settings";
import { Route as AppSpecialistsRouteImport } from "./routes/_app.specialists";
import { Route as AppCatalogIndexRouteImport } from "./routes/_app.catalog.index";
import { Route as AppCatalogAreasRouteImport } from "./routes/_app.catalog.areas";
import { Route as AppCatalogListsRouteImport } from "./routes/_app.catalog.lists";
import { Route as AppCatalogPricesRouteImport } from "./routes/_app.catalog.prices";
import { Route as AppCatalogProfessionsRouteImport } from "./routes/_app.catalog.professions";
import { Route as AppCatalogServicesRouteImport } from "./routes/_app.catalog.services";
import { Route as AppClientsIndexRouteImport } from "./routes/_app.clients.index";
import { Route as AppClientsUserIdRouteImport } from "./routes/_app.clients.$userId";
import { Route as AppClientsBlocksRouteImport } from "./routes/_app.clients.blocks";
import { Route as AppGrowthIndexRouteImport } from "./routes/_app.growth.index";
import { Route as AppGrowthCampaignsRouteImport } from "./routes/_app.growth.campaigns";
import { Route as AppGrowthLegalRouteImport } from "./routes/_app.growth.legal";
import { Route as AppGrowthMessagesRouteImport } from "./routes/_app.growth.messages";
import { Route as AppGrowthNewsRouteImport } from "./routes/_app.growth.news";
import { Route as AppGrowthPartnersRouteImport } from "./routes/_app.growth.partners";
import { Route as AppGrowthPromoCodesRouteImport } from "./routes/_app.growth.promo-codes";
import { Route as AppGrowthStoriesRouteImport } from "./routes/_app.growth.stories";
import { Route as AppMoneyIndexRouteImport } from "./routes/_app.money.index";
import { Route as AppMoneyAdjustmentsRouteImport } from "./routes/_app.money.adjustments";
import { Route as AppMoneyBankCallsRouteImport } from "./routes/_app.money.bank-calls";
import { Route as AppMoneyChannelsRouteImport } from "./routes/_app.money.channels";
import { Route as AppMoneyLedgerRouteImport } from "./routes/_app.money.ledger";
import { Route as AppMoneyPayoutsRouteImport } from "./routes/_app.money.payouts";
import { Route as AppMoneyReportRouteImport } from "./routes/_app.money.report";
import { Route as AppMoneyTopupsRouteImport } from "./routes/_app.money.topups";
import { Route as AppMoneyWalletsRouteImport } from "./routes/_app.money.wallets";
import { Route as AppOrdersIndexRouteImport } from "./routes/_app.orders.index";
import { Route as AppOrdersOrderIdRouteImport } from "./routes/_app.orders.$orderId";
import { Route as AppOrdersCourseChecksRouteImport } from "./routes/_app.orders.course-checks";
import { Route as AppOrdersMapRouteImport } from "./routes/_app.orders.map";
import { Route as AppOrdersNewRouteImport } from "./routes/_app.orders.new";
import { Route as AppSettingsIndexRouteImport } from "./routes/_app.settings.index";
import { Route as AppSettingsActionsRouteImport } from "./routes/_app.settings.actions";
import { Route as AppSettingsAppsRouteImport } from "./routes/_app.settings.apps";
import { Route as AppSettingsAuditRouteImport } from "./routes/_app.settings.audit";
import { Route as AppSettingsCourseBonusRouteImport } from "./routes/_app.settings.course-bonus";
import { Route as AppSettingsCoursePricesRouteImport } from "./routes/_app.settings.course-prices";
import { Route as AppSettingsDispatchRouteImport } from "./routes/_app.settings.dispatch";
import { Route as AppSettingsMarketsRouteImport } from "./routes/_app.settings.markets";
import { Route as AppSettingsPartnerDeliveriesRouteImport } from "./routes/_app.settings.partner-deliveries";
import { Route as AppSettingsPartnersRouteImport } from "./routes/_app.settings.partners";
import { Route as AppSettingsStaffRouteImport } from "./routes/_app.settings.staff";
import { Route as AppSettingsStuckVisitsRouteImport } from "./routes/_app.settings.stuck-visits";
import { Route as AppSettingsAccountRouteImport } from "./routes/_app.settings_.account";
import { Route as AppSoonEntryRouteImport } from "./routes/_app.soon.$entry";
import { Route as AppSpecialistsIndexRouteImport } from "./routes/_app.specialists.index";
import { Route as AppSpecialistsUserIdRouteImport } from "./routes/_app.specialists.$userId";
import { Route as AppSpecialistsBlockedRouteImport } from "./routes/_app.specialists.blocked";
import { Route as AppSpecialistsRatingsRouteImport } from "./routes/_app.specialists.ratings";
import { Route as AppSpecialistsSupportRouteImport } from "./routes/_app.specialists.support";
import { Route as AppCatalogServicesIndexRouteImport } from "./routes/_app.catalog.services.index";
import { Route as AppCatalogServicesServiceIdRouteImport } from "./routes/_app.catalog.services.$serviceId";
import { Route as AppCatalogServicesNewRouteImport } from "./routes/_app.catalog.services.new";
import { Route as AppGrowthCampaignsIndexRouteImport } from "./routes/_app.growth.campaigns.index";
import { Route as AppGrowthCampaignsCampaignIdRouteImport } from "./routes/_app.growth.campaigns.$campaignId";
import { Route as AppGrowthLegalIndexRouteImport } from "./routes/_app.growth.legal.index";
import { Route as AppGrowthLegalVersionIdRouteImport } from "./routes/_app.growth.legal.$versionId";
import { Route as AppGrowthLegalNewRouteImport } from "./routes/_app.growth.legal.new";
import { Route as AppGrowthMessagesIndexRouteImport } from "./routes/_app.growth.messages.index";
import { Route as AppGrowthNewsIndexRouteImport } from "./routes/_app.growth.news.index";
import { Route as AppGrowthNewsNewsIdRouteImport } from "./routes/_app.growth.news.$newsId";
import { Route as AppGrowthNewsNewRouteImport } from "./routes/_app.growth.news.new";
import { Route as AppGrowthPromoCodesIndexRouteImport } from "./routes/_app.growth.promo-codes.index";
import { Route as AppGrowthPromoCodesPromoIdRouteImport } from "./routes/_app.growth.promo-codes.$promoId";
import { Route as AppGrowthStoriesIndexRouteImport } from "./routes/_app.growth.stories.index";
import { Route as AppGrowthStoriesStoryIdRouteImport } from "./routes/_app.growth.stories.$storyId";
import { Route as AppGrowthStoriesNewRouteImport } from "./routes/_app.growth.stories.new";
import { Route as AppMoneyAdjustmentsIndexRouteImport } from "./routes/_app.money.adjustments.index";
import { Route as AppMoneyAdjustmentsAdjustmentIdRouteImport } from "./routes/_app.money.adjustments.$adjustmentId";
import { Route as AppMoneyPayoutsIndexRouteImport } from "./routes/_app.money.payouts.index";
import { Route as AppMoneyPayoutsPayoutIdRouteImport } from "./routes/_app.money.payouts.$payoutId";
import { Route as AppMoneySpecialistsUserIdRouteImport } from "./routes/_app.money.specialists.$userId";
import { Route as AppMoneyTopupsIndexRouteImport } from "./routes/_app.money.topups.index";
import { Route as AppMoneyTopupsTopupIdRouteImport } from "./routes/_app.money.topups.$topupId";
import { Route as AppMoneyWalletsIndexRouteImport } from "./routes/_app.money.wallets.index";
import { Route as AppMoneyWalletsProviderIdRouteImport } from "./routes/_app.money.wallets.$providerId";
import { Route as AppSettingsStaffIndexRouteImport } from "./routes/_app.settings.staff.index";
import { Route as AppSettingsStaffUserIdRouteImport } from "./routes/_app.settings.staff.$userId";
import { Route as AppSpecialistsSupportIndexRouteImport } from "./routes/_app.specialists.support.index";
import { Route as AppSpecialistsSupportThreadIdRouteImport } from "./routes/_app.specialists.support.$threadId";
import { Route as AppGrowthMessagesPeopleUserIdRouteImport } from "./routes/_app.growth.messages.people.$userId";
import { Route as AppSpecialistsSupportToUserIdRouteImport } from "./routes/_app.specialists.support.to.$userId";

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any);
const AppCatalogRoute = AppCatalogRouteImport.update({
  id: "/catalog",
  path: "/catalog",
  getParentRoute: () => AppRoute,
} as any);
const AppClientsRoute = AppClientsRouteImport.update({
  id: "/clients",
  path: "/clients",
  getParentRoute: () => AppRoute,
} as any);
const AppGrowthRoute = AppGrowthRouteImport.update({
  id: "/growth",
  path: "/growth",
  getParentRoute: () => AppRoute,
} as any);
const AppMoneyRoute = AppMoneyRouteImport.update({
  id: "/money",
  path: "/money",
  getParentRoute: () => AppRoute,
} as any);
const AppNowRoute = AppNowRouteImport.update({
  id: "/now",
  path: "/now",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: "/orders",
  path: "/orders",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any);
const AppSpecialistsRoute = AppSpecialistsRouteImport.update({
  id: "/specialists",
  path: "/specialists",
  getParentRoute: () => AppRoute,
} as any);
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppCatalogAreasRoute = AppCatalogAreasRouteImport.update({
  id: "/areas",
  path: "/areas",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppCatalogListsRoute = AppCatalogListsRouteImport.update({
  id: "/lists",
  path: "/lists",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppCatalogPricesRoute = AppCatalogPricesRouteImport.update({
  id: "/prices",
  path: "/prices",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppCatalogProfessionsRoute = AppCatalogProfessionsRouteImport.update({
  id: "/professions",
  path: "/professions",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppCatalogServicesRoute = AppCatalogServicesRouteImport.update({
  id: "/services",
  path: "/services",
  getParentRoute: () => AppCatalogRoute,
} as any);
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppClientsRoute,
} as any);
const AppClientsUserIdRoute = AppClientsUserIdRouteImport.update({
  id: "/$userId",
  path: "/$userId",
  getParentRoute: () => AppClientsRoute,
} as any);
const AppClientsBlocksRoute = AppClientsBlocksRouteImport.update({
  id: "/blocks",
  path: "/blocks",
  getParentRoute: () => AppClientsRoute,
} as any);
const AppGrowthIndexRoute = AppGrowthIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthCampaignsRoute = AppGrowthCampaignsRouteImport.update({
  id: "/campaigns",
  path: "/campaigns",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthLegalRoute = AppGrowthLegalRouteImport.update({
  id: "/legal",
  path: "/legal",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthMessagesRoute = AppGrowthMessagesRouteImport.update({
  id: "/messages",
  path: "/messages",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthNewsRoute = AppGrowthNewsRouteImport.update({
  id: "/news",
  path: "/news",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthPartnersRoute = AppGrowthPartnersRouteImport.update({
  id: "/partners",
  path: "/partners",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthPromoCodesRoute = AppGrowthPromoCodesRouteImport.update({
  id: "/promo-codes",
  path: "/promo-codes",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppGrowthStoriesRoute = AppGrowthStoriesRouteImport.update({
  id: "/stories",
  path: "/stories",
  getParentRoute: () => AppGrowthRoute,
} as any);
const AppMoneyIndexRoute = AppMoneyIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyAdjustmentsRoute = AppMoneyAdjustmentsRouteImport.update({
  id: "/adjustments",
  path: "/adjustments",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyBankCallsRoute = AppMoneyBankCallsRouteImport.update({
  id: "/bank-calls",
  path: "/bank-calls",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyChannelsRoute = AppMoneyChannelsRouteImport.update({
  id: "/channels",
  path: "/channels",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyLedgerRoute = AppMoneyLedgerRouteImport.update({
  id: "/ledger",
  path: "/ledger",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyPayoutsRoute = AppMoneyPayoutsRouteImport.update({
  id: "/payouts",
  path: "/payouts",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyReportRoute = AppMoneyReportRouteImport.update({
  id: "/report",
  path: "/report",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyTopupsRoute = AppMoneyTopupsRouteImport.update({
  id: "/topups",
  path: "/topups",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppMoneyWalletsRoute = AppMoneyWalletsRouteImport.update({
  id: "/wallets",
  path: "/wallets",
  getParentRoute: () => AppMoneyRoute,
} as any);
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: "/$orderId",
  path: "/$orderId",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppOrdersCourseChecksRoute = AppOrdersCourseChecksRouteImport.update({
  id: "/course-checks",
  path: "/course-checks",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppOrdersMapRoute = AppOrdersMapRouteImport.update({
  id: "/map",
  path: "/map",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppOrdersRoute,
} as any);
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsActionsRoute = AppSettingsActionsRouteImport.update({
  id: "/actions",
  path: "/actions",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAppsRoute = AppSettingsAppsRouteImport.update({
  id: "/apps",
  path: "/apps",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsCourseBonusRoute = AppSettingsCourseBonusRouteImport.update({
  id: "/course-bonus",
  path: "/course-bonus",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsCoursePricesRoute = AppSettingsCoursePricesRouteImport.update({
  id: "/course-prices",
  path: "/course-prices",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsDispatchRoute = AppSettingsDispatchRouteImport.update({
  id: "/dispatch",
  path: "/dispatch",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsMarketsRoute = AppSettingsMarketsRouteImport.update({
  id: "/markets",
  path: "/markets",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsPartnerDeliveriesRoute =
  AppSettingsPartnerDeliveriesRouteImport.update({
    id: "/partner-deliveries",
    path: "/partner-deliveries",
    getParentRoute: () => AppSettingsRoute,
  } as any);
const AppSettingsPartnersRoute = AppSettingsPartnersRouteImport.update({
  id: "/partners",
  path: "/partners",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: "/staff",
  path: "/staff",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsStuckVisitsRoute = AppSettingsStuckVisitsRouteImport.update({
  id: "/stuck-visits",
  path: "/stuck-visits",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: "/settings_/account",
  path: "/settings/account",
  getParentRoute: () => AppRoute,
} as any);
const AppSoonEntryRoute = AppSoonEntryRouteImport.update({
  id: "/soon/$entry",
  path: "/soon/$entry",
  getParentRoute: () => AppRoute,
} as any);
const AppSpecialistsIndexRoute = AppSpecialistsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSpecialistsRoute,
} as any);
const AppSpecialistsUserIdRoute = AppSpecialistsUserIdRouteImport.update({
  id: "/$userId",
  path: "/$userId",
  getParentRoute: () => AppSpecialistsRoute,
} as any);
const AppSpecialistsBlockedRoute = AppSpecialistsBlockedRouteImport.update({
  id: "/blocked",
  path: "/blocked",
  getParentRoute: () => AppSpecialistsRoute,
} as any);
const AppSpecialistsRatingsRoute = AppSpecialistsRatingsRouteImport.update({
  id: "/ratings",
  path: "/ratings",
  getParentRoute: () => AppSpecialistsRoute,
} as any);
const AppSpecialistsSupportRoute = AppSpecialistsSupportRouteImport.update({
  id: "/support",
  path: "/support",
  getParentRoute: () => AppSpecialistsRoute,
} as any);
const AppCatalogServicesIndexRoute = AppCatalogServicesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppCatalogServicesRoute,
} as any);
const AppCatalogServicesServiceIdRoute =
  AppCatalogServicesServiceIdRouteImport.update({
    id: "/$serviceId",
    path: "/$serviceId",
    getParentRoute: () => AppCatalogServicesRoute,
  } as any);
const AppCatalogServicesNewRoute = AppCatalogServicesNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppCatalogServicesRoute,
} as any);
const AppGrowthCampaignsIndexRoute = AppGrowthCampaignsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthCampaignsRoute,
} as any);
const AppGrowthCampaignsCampaignIdRoute =
  AppGrowthCampaignsCampaignIdRouteImport.update({
    id: "/$campaignId",
    path: "/$campaignId",
    getParentRoute: () => AppGrowthCampaignsRoute,
  } as any);
const AppGrowthLegalIndexRoute = AppGrowthLegalIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthLegalRoute,
} as any);
const AppGrowthLegalVersionIdRoute = AppGrowthLegalVersionIdRouteImport.update({
  id: "/$versionId",
  path: "/$versionId",
  getParentRoute: () => AppGrowthLegalRoute,
} as any);
const AppGrowthLegalNewRoute = AppGrowthLegalNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppGrowthLegalRoute,
} as any);
const AppGrowthMessagesIndexRoute = AppGrowthMessagesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthMessagesRoute,
} as any);
const AppGrowthNewsIndexRoute = AppGrowthNewsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthNewsRoute,
} as any);
const AppGrowthNewsNewsIdRoute = AppGrowthNewsNewsIdRouteImport.update({
  id: "/$newsId",
  path: "/$newsId",
  getParentRoute: () => AppGrowthNewsRoute,
} as any);
const AppGrowthNewsNewRoute = AppGrowthNewsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppGrowthNewsRoute,
} as any);
const AppGrowthPromoCodesIndexRoute =
  AppGrowthPromoCodesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AppGrowthPromoCodesRoute,
  } as any);
const AppGrowthPromoCodesPromoIdRoute =
  AppGrowthPromoCodesPromoIdRouteImport.update({
    id: "/$promoId",
    path: "/$promoId",
    getParentRoute: () => AppGrowthPromoCodesRoute,
  } as any);
const AppGrowthStoriesIndexRoute = AppGrowthStoriesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppGrowthStoriesRoute,
} as any);
const AppGrowthStoriesStoryIdRoute = AppGrowthStoriesStoryIdRouteImport.update({
  id: "/$storyId",
  path: "/$storyId",
  getParentRoute: () => AppGrowthStoriesRoute,
} as any);
const AppGrowthStoriesNewRoute = AppGrowthStoriesNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppGrowthStoriesRoute,
} as any);
const AppMoneyAdjustmentsIndexRoute =
  AppMoneyAdjustmentsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AppMoneyAdjustmentsRoute,
  } as any);
const AppMoneyAdjustmentsAdjustmentIdRoute =
  AppMoneyAdjustmentsAdjustmentIdRouteImport.update({
    id: "/$adjustmentId",
    path: "/$adjustmentId",
    getParentRoute: () => AppMoneyAdjustmentsRoute,
  } as any);
const AppMoneyPayoutsIndexRoute = AppMoneyPayoutsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMoneyPayoutsRoute,
} as any);
const AppMoneyPayoutsPayoutIdRoute = AppMoneyPayoutsPayoutIdRouteImport.update({
  id: "/$payoutId",
  path: "/$payoutId",
  getParentRoute: () => AppMoneyPayoutsRoute,
} as any);
const AppMoneySpecialistsUserIdRoute =
  AppMoneySpecialistsUserIdRouteImport.update({
    id: "/specialists/$userId",
    path: "/specialists/$userId",
    getParentRoute: () => AppMoneyRoute,
  } as any);
const AppMoneyTopupsIndexRoute = AppMoneyTopupsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMoneyTopupsRoute,
} as any);
const AppMoneyTopupsTopupIdRoute = AppMoneyTopupsTopupIdRouteImport.update({
  id: "/$topupId",
  path: "/$topupId",
  getParentRoute: () => AppMoneyTopupsRoute,
} as any);
const AppMoneyWalletsIndexRoute = AppMoneyWalletsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppMoneyWalletsRoute,
} as any);
const AppMoneyWalletsProviderIdRoute =
  AppMoneyWalletsProviderIdRouteImport.update({
    id: "/$providerId",
    path: "/$providerId",
    getParentRoute: () => AppMoneyWalletsRoute,
  } as any);
const AppSettingsStaffIndexRoute = AppSettingsStaffIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSettingsStaffRoute,
} as any);
const AppSettingsStaffUserIdRoute = AppSettingsStaffUserIdRouteImport.update({
  id: "/$userId",
  path: "/$userId",
  getParentRoute: () => AppSettingsStaffRoute,
} as any);
const AppSpecialistsSupportIndexRoute =
  AppSpecialistsSupportIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AppSpecialistsSupportRoute,
  } as any);
const AppSpecialistsSupportThreadIdRoute =
  AppSpecialistsSupportThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AppSpecialistsSupportRoute,
  } as any);
const AppGrowthMessagesPeopleUserIdRoute =
  AppGrowthMessagesPeopleUserIdRouteImport.update({
    id: "/people/$userId",
    path: "/people/$userId",
    getParentRoute: () => AppGrowthMessagesRoute,
  } as any);
const AppSpecialistsSupportToUserIdRoute =
  AppSpecialistsSupportToUserIdRouteImport.update({
    id: "/to/$userId",
    path: "/to/$userId",
    getParentRoute: () => AppSpecialistsSupportRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute;
  "/sign-in": typeof SignInRoute;
  "/catalog": typeof AppCatalogRouteWithChildren;
  "/clients": typeof AppClientsRouteWithChildren;
  "/growth": typeof AppGrowthRouteWithChildren;
  "/money": typeof AppMoneyRouteWithChildren;
  "/now": typeof AppNowRoute;
  "/orders": typeof AppOrdersRouteWithChildren;
  "/settings": typeof AppSettingsRouteWithChildren;
  "/specialists": typeof AppSpecialistsRouteWithChildren;
  "/catalog/areas": typeof AppCatalogAreasRoute;
  "/catalog/lists": typeof AppCatalogListsRoute;
  "/catalog/prices": typeof AppCatalogPricesRoute;
  "/catalog/professions": typeof AppCatalogProfessionsRoute;
  "/catalog/services": typeof AppCatalogServicesRouteWithChildren;
  "/clients/$userId": typeof AppClientsUserIdRoute;
  "/clients/blocks": typeof AppClientsBlocksRoute;
  "/growth/campaigns": typeof AppGrowthCampaignsRouteWithChildren;
  "/growth/legal": typeof AppGrowthLegalRouteWithChildren;
  "/growth/messages": typeof AppGrowthMessagesRouteWithChildren;
  "/growth/news": typeof AppGrowthNewsRouteWithChildren;
  "/growth/partners": typeof AppGrowthPartnersRoute;
  "/growth/promo-codes": typeof AppGrowthPromoCodesRouteWithChildren;
  "/growth/stories": typeof AppGrowthStoriesRouteWithChildren;
  "/money/adjustments": typeof AppMoneyAdjustmentsRouteWithChildren;
  "/money/bank-calls": typeof AppMoneyBankCallsRoute;
  "/money/channels": typeof AppMoneyChannelsRoute;
  "/money/ledger": typeof AppMoneyLedgerRoute;
  "/money/payouts": typeof AppMoneyPayoutsRouteWithChildren;
  "/money/report": typeof AppMoneyReportRoute;
  "/money/topups": typeof AppMoneyTopupsRouteWithChildren;
  "/money/wallets": typeof AppMoneyWalletsRouteWithChildren;
  "/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/orders/course-checks": typeof AppOrdersCourseChecksRoute;
  "/orders/map": typeof AppOrdersMapRoute;
  "/orders/new": typeof AppOrdersNewRoute;
  "/settings/actions": typeof AppSettingsActionsRoute;
  "/settings/apps": typeof AppSettingsAppsRoute;
  "/settings/audit": typeof AppSettingsAuditRoute;
  "/settings/course-bonus": typeof AppSettingsCourseBonusRoute;
  "/settings/course-prices": typeof AppSettingsCoursePricesRoute;
  "/settings/dispatch": typeof AppSettingsDispatchRoute;
  "/settings/markets": typeof AppSettingsMarketsRoute;
  "/settings/partner-deliveries": typeof AppSettingsPartnerDeliveriesRoute;
  "/settings/partners": typeof AppSettingsPartnersRoute;
  "/settings/staff": typeof AppSettingsStaffRouteWithChildren;
  "/settings/stuck-visits": typeof AppSettingsStuckVisitsRoute;
  "/settings/account": typeof AppSettingsAccountRoute;
  "/soon/$entry": typeof AppSoonEntryRoute;
  "/specialists/$userId": typeof AppSpecialistsUserIdRoute;
  "/specialists/blocked": typeof AppSpecialistsBlockedRoute;
  "/specialists/ratings": typeof AppSpecialistsRatingsRoute;
  "/specialists/support": typeof AppSpecialistsSupportRouteWithChildren;
  "/catalog/": typeof AppCatalogIndexRoute;
  "/clients/": typeof AppClientsIndexRoute;
  "/growth/": typeof AppGrowthIndexRoute;
  "/money/": typeof AppMoneyIndexRoute;
  "/orders/": typeof AppOrdersIndexRoute;
  "/settings/": typeof AppSettingsIndexRoute;
  "/specialists/": typeof AppSpecialistsIndexRoute;
  "/catalog/services/$serviceId": typeof AppCatalogServicesServiceIdRoute;
  "/catalog/services/new": typeof AppCatalogServicesNewRoute;
  "/growth/campaigns/$campaignId": typeof AppGrowthCampaignsCampaignIdRoute;
  "/growth/legal/$versionId": typeof AppGrowthLegalVersionIdRoute;
  "/growth/legal/new": typeof AppGrowthLegalNewRoute;
  "/growth/news/$newsId": typeof AppGrowthNewsNewsIdRoute;
  "/growth/news/new": typeof AppGrowthNewsNewRoute;
  "/growth/promo-codes/$promoId": typeof AppGrowthPromoCodesPromoIdRoute;
  "/growth/stories/$storyId": typeof AppGrowthStoriesStoryIdRoute;
  "/growth/stories/new": typeof AppGrowthStoriesNewRoute;
  "/money/adjustments/$adjustmentId": typeof AppMoneyAdjustmentsAdjustmentIdRoute;
  "/money/payouts/$payoutId": typeof AppMoneyPayoutsPayoutIdRoute;
  "/money/specialists/$userId": typeof AppMoneySpecialistsUserIdRoute;
  "/money/topups/$topupId": typeof AppMoneyTopupsTopupIdRoute;
  "/money/wallets/$providerId": typeof AppMoneyWalletsProviderIdRoute;
  "/settings/staff/$userId": typeof AppSettingsStaffUserIdRoute;
  "/specialists/support/$threadId": typeof AppSpecialistsSupportThreadIdRoute;
  "/catalog/services/": typeof AppCatalogServicesIndexRoute;
  "/growth/campaigns/": typeof AppGrowthCampaignsIndexRoute;
  "/growth/legal/": typeof AppGrowthLegalIndexRoute;
  "/growth/messages/": typeof AppGrowthMessagesIndexRoute;
  "/growth/news/": typeof AppGrowthNewsIndexRoute;
  "/growth/promo-codes/": typeof AppGrowthPromoCodesIndexRoute;
  "/growth/stories/": typeof AppGrowthStoriesIndexRoute;
  "/money/adjustments/": typeof AppMoneyAdjustmentsIndexRoute;
  "/money/payouts/": typeof AppMoneyPayoutsIndexRoute;
  "/money/topups/": typeof AppMoneyTopupsIndexRoute;
  "/money/wallets/": typeof AppMoneyWalletsIndexRoute;
  "/settings/staff/": typeof AppSettingsStaffIndexRoute;
  "/specialists/support/": typeof AppSpecialistsSupportIndexRoute;
  "/growth/messages/people/$userId": typeof AppGrowthMessagesPeopleUserIdRoute;
  "/specialists/support/to/$userId": typeof AppSpecialistsSupportToUserIdRoute;
}
export interface FileRoutesByTo {
  "/sign-in": typeof SignInRoute;
  "/now": typeof AppNowRoute;
  "/": typeof AppIndexRoute;
  "/catalog/areas": typeof AppCatalogAreasRoute;
  "/catalog/lists": typeof AppCatalogListsRoute;
  "/catalog/prices": typeof AppCatalogPricesRoute;
  "/catalog/professions": typeof AppCatalogProfessionsRoute;
  "/clients/$userId": typeof AppClientsUserIdRoute;
  "/clients/blocks": typeof AppClientsBlocksRoute;
  "/growth/partners": typeof AppGrowthPartnersRoute;
  "/money/bank-calls": typeof AppMoneyBankCallsRoute;
  "/money/channels": typeof AppMoneyChannelsRoute;
  "/money/ledger": typeof AppMoneyLedgerRoute;
  "/money/report": typeof AppMoneyReportRoute;
  "/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/orders/course-checks": typeof AppOrdersCourseChecksRoute;
  "/orders/map": typeof AppOrdersMapRoute;
  "/orders/new": typeof AppOrdersNewRoute;
  "/settings/actions": typeof AppSettingsActionsRoute;
  "/settings/apps": typeof AppSettingsAppsRoute;
  "/settings/audit": typeof AppSettingsAuditRoute;
  "/settings/course-bonus": typeof AppSettingsCourseBonusRoute;
  "/settings/course-prices": typeof AppSettingsCoursePricesRoute;
  "/settings/dispatch": typeof AppSettingsDispatchRoute;
  "/settings/markets": typeof AppSettingsMarketsRoute;
  "/settings/partner-deliveries": typeof AppSettingsPartnerDeliveriesRoute;
  "/settings/partners": typeof AppSettingsPartnersRoute;
  "/settings/stuck-visits": typeof AppSettingsStuckVisitsRoute;
  "/settings/account": typeof AppSettingsAccountRoute;
  "/soon/$entry": typeof AppSoonEntryRoute;
  "/specialists/$userId": typeof AppSpecialistsUserIdRoute;
  "/specialists/blocked": typeof AppSpecialistsBlockedRoute;
  "/specialists/ratings": typeof AppSpecialistsRatingsRoute;
  "/catalog": typeof AppCatalogIndexRoute;
  "/clients": typeof AppClientsIndexRoute;
  "/growth": typeof AppGrowthIndexRoute;
  "/money": typeof AppMoneyIndexRoute;
  "/orders": typeof AppOrdersIndexRoute;
  "/settings": typeof AppSettingsIndexRoute;
  "/specialists": typeof AppSpecialistsIndexRoute;
  "/catalog/services/$serviceId": typeof AppCatalogServicesServiceIdRoute;
  "/catalog/services/new": typeof AppCatalogServicesNewRoute;
  "/growth/campaigns/$campaignId": typeof AppGrowthCampaignsCampaignIdRoute;
  "/growth/legal/$versionId": typeof AppGrowthLegalVersionIdRoute;
  "/growth/legal/new": typeof AppGrowthLegalNewRoute;
  "/growth/news/$newsId": typeof AppGrowthNewsNewsIdRoute;
  "/growth/news/new": typeof AppGrowthNewsNewRoute;
  "/growth/promo-codes/$promoId": typeof AppGrowthPromoCodesPromoIdRoute;
  "/growth/stories/$storyId": typeof AppGrowthStoriesStoryIdRoute;
  "/growth/stories/new": typeof AppGrowthStoriesNewRoute;
  "/money/adjustments/$adjustmentId": typeof AppMoneyAdjustmentsAdjustmentIdRoute;
  "/money/payouts/$payoutId": typeof AppMoneyPayoutsPayoutIdRoute;
  "/money/specialists/$userId": typeof AppMoneySpecialistsUserIdRoute;
  "/money/topups/$topupId": typeof AppMoneyTopupsTopupIdRoute;
  "/money/wallets/$providerId": typeof AppMoneyWalletsProviderIdRoute;
  "/settings/staff/$userId": typeof AppSettingsStaffUserIdRoute;
  "/specialists/support/$threadId": typeof AppSpecialistsSupportThreadIdRoute;
  "/catalog/services": typeof AppCatalogServicesIndexRoute;
  "/growth/campaigns": typeof AppGrowthCampaignsIndexRoute;
  "/growth/legal": typeof AppGrowthLegalIndexRoute;
  "/growth/messages": typeof AppGrowthMessagesIndexRoute;
  "/growth/news": typeof AppGrowthNewsIndexRoute;
  "/growth/promo-codes": typeof AppGrowthPromoCodesIndexRoute;
  "/growth/stories": typeof AppGrowthStoriesIndexRoute;
  "/money/adjustments": typeof AppMoneyAdjustmentsIndexRoute;
  "/money/payouts": typeof AppMoneyPayoutsIndexRoute;
  "/money/topups": typeof AppMoneyTopupsIndexRoute;
  "/money/wallets": typeof AppMoneyWalletsIndexRoute;
  "/settings/staff": typeof AppSettingsStaffIndexRoute;
  "/specialists/support": typeof AppSpecialistsSupportIndexRoute;
  "/growth/messages/people/$userId": typeof AppGrowthMessagesPeopleUserIdRoute;
  "/specialists/support/to/$userId": typeof AppSpecialistsSupportToUserIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_app": typeof AppRouteWithChildren;
  "/sign-in": typeof SignInRoute;
  "/_app/catalog": typeof AppCatalogRouteWithChildren;
  "/_app/clients": typeof AppClientsRouteWithChildren;
  "/_app/growth": typeof AppGrowthRouteWithChildren;
  "/_app/money": typeof AppMoneyRouteWithChildren;
  "/_app/now": typeof AppNowRoute;
  "/_app/orders": typeof AppOrdersRouteWithChildren;
  "/_app/settings": typeof AppSettingsRouteWithChildren;
  "/_app/specialists": typeof AppSpecialistsRouteWithChildren;
  "/_app/": typeof AppIndexRoute;
  "/_app/catalog/areas": typeof AppCatalogAreasRoute;
  "/_app/catalog/lists": typeof AppCatalogListsRoute;
  "/_app/catalog/prices": typeof AppCatalogPricesRoute;
  "/_app/catalog/professions": typeof AppCatalogProfessionsRoute;
  "/_app/catalog/services": typeof AppCatalogServicesRouteWithChildren;
  "/_app/clients/$userId": typeof AppClientsUserIdRoute;
  "/_app/clients/blocks": typeof AppClientsBlocksRoute;
  "/_app/growth/campaigns": typeof AppGrowthCampaignsRouteWithChildren;
  "/_app/growth/legal": typeof AppGrowthLegalRouteWithChildren;
  "/_app/growth/messages": typeof AppGrowthMessagesRouteWithChildren;
  "/_app/growth/news": typeof AppGrowthNewsRouteWithChildren;
  "/_app/growth/partners": typeof AppGrowthPartnersRoute;
  "/_app/growth/promo-codes": typeof AppGrowthPromoCodesRouteWithChildren;
  "/_app/growth/stories": typeof AppGrowthStoriesRouteWithChildren;
  "/_app/money/adjustments": typeof AppMoneyAdjustmentsRouteWithChildren;
  "/_app/money/bank-calls": typeof AppMoneyBankCallsRoute;
  "/_app/money/channels": typeof AppMoneyChannelsRoute;
  "/_app/money/ledger": typeof AppMoneyLedgerRoute;
  "/_app/money/payouts": typeof AppMoneyPayoutsRouteWithChildren;
  "/_app/money/report": typeof AppMoneyReportRoute;
  "/_app/money/topups": typeof AppMoneyTopupsRouteWithChildren;
  "/_app/money/wallets": typeof AppMoneyWalletsRouteWithChildren;
  "/_app/orders/$orderId": typeof AppOrdersOrderIdRoute;
  "/_app/orders/course-checks": typeof AppOrdersCourseChecksRoute;
  "/_app/orders/map": typeof AppOrdersMapRoute;
  "/_app/orders/new": typeof AppOrdersNewRoute;
  "/_app/settings/actions": typeof AppSettingsActionsRoute;
  "/_app/settings/apps": typeof AppSettingsAppsRoute;
  "/_app/settings/audit": typeof AppSettingsAuditRoute;
  "/_app/settings/course-bonus": typeof AppSettingsCourseBonusRoute;
  "/_app/settings/course-prices": typeof AppSettingsCoursePricesRoute;
  "/_app/settings/dispatch": typeof AppSettingsDispatchRoute;
  "/_app/settings/markets": typeof AppSettingsMarketsRoute;
  "/_app/settings/partner-deliveries": typeof AppSettingsPartnerDeliveriesRoute;
  "/_app/settings/partners": typeof AppSettingsPartnersRoute;
  "/_app/settings/staff": typeof AppSettingsStaffRouteWithChildren;
  "/_app/settings/stuck-visits": typeof AppSettingsStuckVisitsRoute;
  "/_app/settings_/account": typeof AppSettingsAccountRoute;
  "/_app/soon/$entry": typeof AppSoonEntryRoute;
  "/_app/specialists/$userId": typeof AppSpecialistsUserIdRoute;
  "/_app/specialists/blocked": typeof AppSpecialistsBlockedRoute;
  "/_app/specialists/ratings": typeof AppSpecialistsRatingsRoute;
  "/_app/specialists/support": typeof AppSpecialistsSupportRouteWithChildren;
  "/_app/catalog/": typeof AppCatalogIndexRoute;
  "/_app/clients/": typeof AppClientsIndexRoute;
  "/_app/growth/": typeof AppGrowthIndexRoute;
  "/_app/money/": typeof AppMoneyIndexRoute;
  "/_app/orders/": typeof AppOrdersIndexRoute;
  "/_app/settings/": typeof AppSettingsIndexRoute;
  "/_app/specialists/": typeof AppSpecialistsIndexRoute;
  "/_app/catalog/services/$serviceId": typeof AppCatalogServicesServiceIdRoute;
  "/_app/catalog/services/new": typeof AppCatalogServicesNewRoute;
  "/_app/growth/campaigns/$campaignId": typeof AppGrowthCampaignsCampaignIdRoute;
  "/_app/growth/legal/$versionId": typeof AppGrowthLegalVersionIdRoute;
  "/_app/growth/legal/new": typeof AppGrowthLegalNewRoute;
  "/_app/growth/news/$newsId": typeof AppGrowthNewsNewsIdRoute;
  "/_app/growth/news/new": typeof AppGrowthNewsNewRoute;
  "/_app/growth/promo-codes/$promoId": typeof AppGrowthPromoCodesPromoIdRoute;
  "/_app/growth/stories/$storyId": typeof AppGrowthStoriesStoryIdRoute;
  "/_app/growth/stories/new": typeof AppGrowthStoriesNewRoute;
  "/_app/money/adjustments/$adjustmentId": typeof AppMoneyAdjustmentsAdjustmentIdRoute;
  "/_app/money/payouts/$payoutId": typeof AppMoneyPayoutsPayoutIdRoute;
  "/_app/money/specialists/$userId": typeof AppMoneySpecialistsUserIdRoute;
  "/_app/money/topups/$topupId": typeof AppMoneyTopupsTopupIdRoute;
  "/_app/money/wallets/$providerId": typeof AppMoneyWalletsProviderIdRoute;
  "/_app/settings/staff/$userId": typeof AppSettingsStaffUserIdRoute;
  "/_app/specialists/support/$threadId": typeof AppSpecialistsSupportThreadIdRoute;
  "/_app/catalog/services/": typeof AppCatalogServicesIndexRoute;
  "/_app/growth/campaigns/": typeof AppGrowthCampaignsIndexRoute;
  "/_app/growth/legal/": typeof AppGrowthLegalIndexRoute;
  "/_app/growth/messages/": typeof AppGrowthMessagesIndexRoute;
  "/_app/growth/news/": typeof AppGrowthNewsIndexRoute;
  "/_app/growth/promo-codes/": typeof AppGrowthPromoCodesIndexRoute;
  "/_app/growth/stories/": typeof AppGrowthStoriesIndexRoute;
  "/_app/money/adjustments/": typeof AppMoneyAdjustmentsIndexRoute;
  "/_app/money/payouts/": typeof AppMoneyPayoutsIndexRoute;
  "/_app/money/topups/": typeof AppMoneyTopupsIndexRoute;
  "/_app/money/wallets/": typeof AppMoneyWalletsIndexRoute;
  "/_app/settings/staff/": typeof AppSettingsStaffIndexRoute;
  "/_app/specialists/support/": typeof AppSpecialistsSupportIndexRoute;
  "/_app/growth/messages/people/$userId": typeof AppGrowthMessagesPeopleUserIdRoute;
  "/_app/specialists/support/to/$userId": typeof AppSpecialistsSupportToUserIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/sign-in"
    | "/catalog"
    | "/clients"
    | "/growth"
    | "/money"
    | "/now"
    | "/orders"
    | "/settings"
    | "/specialists"
    | "/catalog/areas"
    | "/catalog/lists"
    | "/catalog/prices"
    | "/catalog/professions"
    | "/catalog/services"
    | "/clients/$userId"
    | "/clients/blocks"
    | "/growth/campaigns"
    | "/growth/legal"
    | "/growth/messages"
    | "/growth/news"
    | "/growth/partners"
    | "/growth/promo-codes"
    | "/growth/stories"
    | "/money/adjustments"
    | "/money/bank-calls"
    | "/money/channels"
    | "/money/ledger"
    | "/money/payouts"
    | "/money/report"
    | "/money/topups"
    | "/money/wallets"
    | "/orders/$orderId"
    | "/orders/course-checks"
    | "/orders/map"
    | "/orders/new"
    | "/settings/actions"
    | "/settings/apps"
    | "/settings/audit"
    | "/settings/course-bonus"
    | "/settings/course-prices"
    | "/settings/dispatch"
    | "/settings/markets"
    | "/settings/partner-deliveries"
    | "/settings/partners"
    | "/settings/staff"
    | "/settings/stuck-visits"
    | "/settings/account"
    | "/soon/$entry"
    | "/specialists/$userId"
    | "/specialists/blocked"
    | "/specialists/ratings"
    | "/specialists/support"
    | "/catalog/"
    | "/clients/"
    | "/growth/"
    | "/money/"
    | "/orders/"
    | "/settings/"
    | "/specialists/"
    | "/catalog/services/$serviceId"
    | "/catalog/services/new"
    | "/growth/campaigns/$campaignId"
    | "/growth/legal/$versionId"
    | "/growth/legal/new"
    | "/growth/news/$newsId"
    | "/growth/news/new"
    | "/growth/promo-codes/$promoId"
    | "/growth/stories/$storyId"
    | "/growth/stories/new"
    | "/money/adjustments/$adjustmentId"
    | "/money/payouts/$payoutId"
    | "/money/specialists/$userId"
    | "/money/topups/$topupId"
    | "/money/wallets/$providerId"
    | "/settings/staff/$userId"
    | "/specialists/support/$threadId"
    | "/catalog/services/"
    | "/growth/campaigns/"
    | "/growth/legal/"
    | "/growth/messages/"
    | "/growth/news/"
    | "/growth/promo-codes/"
    | "/growth/stories/"
    | "/money/adjustments/"
    | "/money/payouts/"
    | "/money/topups/"
    | "/money/wallets/"
    | "/settings/staff/"
    | "/specialists/support/"
    | "/growth/messages/people/$userId"
    | "/specialists/support/to/$userId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/sign-in"
    | "/now"
    | "/"
    | "/catalog/areas"
    | "/catalog/lists"
    | "/catalog/prices"
    | "/catalog/professions"
    | "/clients/$userId"
    | "/clients/blocks"
    | "/growth/partners"
    | "/money/bank-calls"
    | "/money/channels"
    | "/money/ledger"
    | "/money/report"
    | "/orders/$orderId"
    | "/orders/course-checks"
    | "/orders/map"
    | "/orders/new"
    | "/settings/actions"
    | "/settings/apps"
    | "/settings/audit"
    | "/settings/course-bonus"
    | "/settings/course-prices"
    | "/settings/dispatch"
    | "/settings/markets"
    | "/settings/partner-deliveries"
    | "/settings/partners"
    | "/settings/stuck-visits"
    | "/settings/account"
    | "/soon/$entry"
    | "/specialists/$userId"
    | "/specialists/blocked"
    | "/specialists/ratings"
    | "/catalog"
    | "/clients"
    | "/growth"
    | "/money"
    | "/orders"
    | "/settings"
    | "/specialists"
    | "/catalog/services/$serviceId"
    | "/catalog/services/new"
    | "/growth/campaigns/$campaignId"
    | "/growth/legal/$versionId"
    | "/growth/legal/new"
    | "/growth/news/$newsId"
    | "/growth/news/new"
    | "/growth/promo-codes/$promoId"
    | "/growth/stories/$storyId"
    | "/growth/stories/new"
    | "/money/adjustments/$adjustmentId"
    | "/money/payouts/$payoutId"
    | "/money/specialists/$userId"
    | "/money/topups/$topupId"
    | "/money/wallets/$providerId"
    | "/settings/staff/$userId"
    | "/specialists/support/$threadId"
    | "/catalog/services"
    | "/growth/campaigns"
    | "/growth/legal"
    | "/growth/messages"
    | "/growth/news"
    | "/growth/promo-codes"
    | "/growth/stories"
    | "/money/adjustments"
    | "/money/payouts"
    | "/money/topups"
    | "/money/wallets"
    | "/settings/staff"
    | "/specialists/support"
    | "/growth/messages/people/$userId"
    | "/specialists/support/to/$userId";
  id:
    | "__root__"
    | "/_app"
    | "/sign-in"
    | "/_app/catalog"
    | "/_app/clients"
    | "/_app/growth"
    | "/_app/money"
    | "/_app/now"
    | "/_app/orders"
    | "/_app/settings"
    | "/_app/specialists"
    | "/_app/"
    | "/_app/catalog/areas"
    | "/_app/catalog/lists"
    | "/_app/catalog/prices"
    | "/_app/catalog/professions"
    | "/_app/catalog/services"
    | "/_app/clients/$userId"
    | "/_app/clients/blocks"
    | "/_app/growth/campaigns"
    | "/_app/growth/legal"
    | "/_app/growth/messages"
    | "/_app/growth/news"
    | "/_app/growth/partners"
    | "/_app/growth/promo-codes"
    | "/_app/growth/stories"
    | "/_app/money/adjustments"
    | "/_app/money/bank-calls"
    | "/_app/money/channels"
    | "/_app/money/ledger"
    | "/_app/money/payouts"
    | "/_app/money/report"
    | "/_app/money/topups"
    | "/_app/money/wallets"
    | "/_app/orders/$orderId"
    | "/_app/orders/course-checks"
    | "/_app/orders/map"
    | "/_app/orders/new"
    | "/_app/settings/actions"
    | "/_app/settings/apps"
    | "/_app/settings/audit"
    | "/_app/settings/course-bonus"
    | "/_app/settings/course-prices"
    | "/_app/settings/dispatch"
    | "/_app/settings/markets"
    | "/_app/settings/partner-deliveries"
    | "/_app/settings/partners"
    | "/_app/settings/staff"
    | "/_app/settings/stuck-visits"
    | "/_app/settings_/account"
    | "/_app/soon/$entry"
    | "/_app/specialists/$userId"
    | "/_app/specialists/blocked"
    | "/_app/specialists/ratings"
    | "/_app/specialists/support"
    | "/_app/catalog/"
    | "/_app/clients/"
    | "/_app/growth/"
    | "/_app/money/"
    | "/_app/orders/"
    | "/_app/settings/"
    | "/_app/specialists/"
    | "/_app/catalog/services/$serviceId"
    | "/_app/catalog/services/new"
    | "/_app/growth/campaigns/$campaignId"
    | "/_app/growth/legal/$versionId"
    | "/_app/growth/legal/new"
    | "/_app/growth/news/$newsId"
    | "/_app/growth/news/new"
    | "/_app/growth/promo-codes/$promoId"
    | "/_app/growth/stories/$storyId"
    | "/_app/growth/stories/new"
    | "/_app/money/adjustments/$adjustmentId"
    | "/_app/money/payouts/$payoutId"
    | "/_app/money/specialists/$userId"
    | "/_app/money/topups/$topupId"
    | "/_app/money/wallets/$providerId"
    | "/_app/settings/staff/$userId"
    | "/_app/specialists/support/$threadId"
    | "/_app/catalog/services/"
    | "/_app/growth/campaigns/"
    | "/_app/growth/legal/"
    | "/_app/growth/messages/"
    | "/_app/growth/news/"
    | "/_app/growth/promo-codes/"
    | "/_app/growth/stories/"
    | "/_app/money/adjustments/"
    | "/_app/money/payouts/"
    | "/_app/money/topups/"
    | "/_app/money/wallets/"
    | "/_app/settings/staff/"
    | "/_app/specialists/support/"
    | "/_app/growth/messages/people/$userId"
    | "/_app/specialists/support/to/$userId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  SignInRoute: typeof SignInRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/": {
      id: "/_app/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/catalog": {
      id: "/_app/catalog";
      path: "/catalog";
      fullPath: "/catalog";
      preLoaderRoute: typeof AppCatalogRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/clients": {
      id: "/_app/clients";
      path: "/clients";
      fullPath: "/clients";
      preLoaderRoute: typeof AppClientsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/growth": {
      id: "/_app/growth";
      path: "/growth";
      fullPath: "/growth";
      preLoaderRoute: typeof AppGrowthRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/money": {
      id: "/_app/money";
      path: "/money";
      fullPath: "/money";
      preLoaderRoute: typeof AppMoneyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/now": {
      id: "/_app/now";
      path: "/now";
      fullPath: "/now";
      preLoaderRoute: typeof AppNowRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders": {
      id: "/_app/orders";
      path: "/orders";
      fullPath: "/orders";
      preLoaderRoute: typeof AppOrdersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings": {
      id: "/_app/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/specialists": {
      id: "/_app/specialists";
      path: "/specialists";
      fullPath: "/specialists";
      preLoaderRoute: typeof AppSpecialistsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/catalog/": {
      id: "/_app/catalog/";
      path: "/";
      fullPath: "/catalog/";
      preLoaderRoute: typeof AppCatalogIndexRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/catalog/areas": {
      id: "/_app/catalog/areas";
      path: "/areas";
      fullPath: "/catalog/areas";
      preLoaderRoute: typeof AppCatalogAreasRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/catalog/lists": {
      id: "/_app/catalog/lists";
      path: "/lists";
      fullPath: "/catalog/lists";
      preLoaderRoute: typeof AppCatalogListsRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/catalog/prices": {
      id: "/_app/catalog/prices";
      path: "/prices";
      fullPath: "/catalog/prices";
      preLoaderRoute: typeof AppCatalogPricesRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/catalog/professions": {
      id: "/_app/catalog/professions";
      path: "/professions";
      fullPath: "/catalog/professions";
      preLoaderRoute: typeof AppCatalogProfessionsRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/catalog/services": {
      id: "/_app/catalog/services";
      path: "/services";
      fullPath: "/catalog/services";
      preLoaderRoute: typeof AppCatalogServicesRouteImport;
      parentRoute: typeof AppCatalogRoute;
    };
    "/_app/clients/": {
      id: "/_app/clients/";
      path: "/";
      fullPath: "/clients/";
      preLoaderRoute: typeof AppClientsIndexRouteImport;
      parentRoute: typeof AppClientsRoute;
    };
    "/_app/clients/$userId": {
      id: "/_app/clients/$userId";
      path: "/$userId";
      fullPath: "/clients/$userId";
      preLoaderRoute: typeof AppClientsUserIdRouteImport;
      parentRoute: typeof AppClientsRoute;
    };
    "/_app/clients/blocks": {
      id: "/_app/clients/blocks";
      path: "/blocks";
      fullPath: "/clients/blocks";
      preLoaderRoute: typeof AppClientsBlocksRouteImport;
      parentRoute: typeof AppClientsRoute;
    };
    "/_app/growth/": {
      id: "/_app/growth/";
      path: "/";
      fullPath: "/growth/";
      preLoaderRoute: typeof AppGrowthIndexRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/campaigns": {
      id: "/_app/growth/campaigns";
      path: "/campaigns";
      fullPath: "/growth/campaigns";
      preLoaderRoute: typeof AppGrowthCampaignsRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/legal": {
      id: "/_app/growth/legal";
      path: "/legal";
      fullPath: "/growth/legal";
      preLoaderRoute: typeof AppGrowthLegalRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/messages": {
      id: "/_app/growth/messages";
      path: "/messages";
      fullPath: "/growth/messages";
      preLoaderRoute: typeof AppGrowthMessagesRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/news": {
      id: "/_app/growth/news";
      path: "/news";
      fullPath: "/growth/news";
      preLoaderRoute: typeof AppGrowthNewsRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/partners": {
      id: "/_app/growth/partners";
      path: "/partners";
      fullPath: "/growth/partners";
      preLoaderRoute: typeof AppGrowthPartnersRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/promo-codes": {
      id: "/_app/growth/promo-codes";
      path: "/promo-codes";
      fullPath: "/growth/promo-codes";
      preLoaderRoute: typeof AppGrowthPromoCodesRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/growth/stories": {
      id: "/_app/growth/stories";
      path: "/stories";
      fullPath: "/growth/stories";
      preLoaderRoute: typeof AppGrowthStoriesRouteImport;
      parentRoute: typeof AppGrowthRoute;
    };
    "/_app/money/": {
      id: "/_app/money/";
      path: "/";
      fullPath: "/money/";
      preLoaderRoute: typeof AppMoneyIndexRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/adjustments": {
      id: "/_app/money/adjustments";
      path: "/adjustments";
      fullPath: "/money/adjustments";
      preLoaderRoute: typeof AppMoneyAdjustmentsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/bank-calls": {
      id: "/_app/money/bank-calls";
      path: "/bank-calls";
      fullPath: "/money/bank-calls";
      preLoaderRoute: typeof AppMoneyBankCallsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/channels": {
      id: "/_app/money/channels";
      path: "/channels";
      fullPath: "/money/channels";
      preLoaderRoute: typeof AppMoneyChannelsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/ledger": {
      id: "/_app/money/ledger";
      path: "/ledger";
      fullPath: "/money/ledger";
      preLoaderRoute: typeof AppMoneyLedgerRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/payouts": {
      id: "/_app/money/payouts";
      path: "/payouts";
      fullPath: "/money/payouts";
      preLoaderRoute: typeof AppMoneyPayoutsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/report": {
      id: "/_app/money/report";
      path: "/report";
      fullPath: "/money/report";
      preLoaderRoute: typeof AppMoneyReportRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/topups": {
      id: "/_app/money/topups";
      path: "/topups";
      fullPath: "/money/topups";
      preLoaderRoute: typeof AppMoneyTopupsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/wallets": {
      id: "/_app/money/wallets";
      path: "/wallets";
      fullPath: "/money/wallets";
      preLoaderRoute: typeof AppMoneyWalletsRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/orders/": {
      id: "/_app/orders/";
      path: "/";
      fullPath: "/orders/";
      preLoaderRoute: typeof AppOrdersIndexRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/orders/$orderId": {
      id: "/_app/orders/$orderId";
      path: "/$orderId";
      fullPath: "/orders/$orderId";
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/orders/course-checks": {
      id: "/_app/orders/course-checks";
      path: "/course-checks";
      fullPath: "/orders/course-checks";
      preLoaderRoute: typeof AppOrdersCourseChecksRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/orders/map": {
      id: "/_app/orders/map";
      path: "/map";
      fullPath: "/orders/map";
      preLoaderRoute: typeof AppOrdersMapRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/orders/new": {
      id: "/_app/orders/new";
      path: "/new";
      fullPath: "/orders/new";
      preLoaderRoute: typeof AppOrdersNewRouteImport;
      parentRoute: typeof AppOrdersRoute;
    };
    "/_app/settings/": {
      id: "/_app/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof AppSettingsIndexRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/actions": {
      id: "/_app/settings/actions";
      path: "/actions";
      fullPath: "/settings/actions";
      preLoaderRoute: typeof AppSettingsActionsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/apps": {
      id: "/_app/settings/apps";
      path: "/apps";
      fullPath: "/settings/apps";
      preLoaderRoute: typeof AppSettingsAppsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/audit": {
      id: "/_app/settings/audit";
      path: "/audit";
      fullPath: "/settings/audit";
      preLoaderRoute: typeof AppSettingsAuditRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/course-bonus": {
      id: "/_app/settings/course-bonus";
      path: "/course-bonus";
      fullPath: "/settings/course-bonus";
      preLoaderRoute: typeof AppSettingsCourseBonusRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/course-prices": {
      id: "/_app/settings/course-prices";
      path: "/course-prices";
      fullPath: "/settings/course-prices";
      preLoaderRoute: typeof AppSettingsCoursePricesRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/dispatch": {
      id: "/_app/settings/dispatch";
      path: "/dispatch";
      fullPath: "/settings/dispatch";
      preLoaderRoute: typeof AppSettingsDispatchRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/markets": {
      id: "/_app/settings/markets";
      path: "/markets";
      fullPath: "/settings/markets";
      preLoaderRoute: typeof AppSettingsMarketsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/partner-deliveries": {
      id: "/_app/settings/partner-deliveries";
      path: "/partner-deliveries";
      fullPath: "/settings/partner-deliveries";
      preLoaderRoute: typeof AppSettingsPartnerDeliveriesRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/partners": {
      id: "/_app/settings/partners";
      path: "/partners";
      fullPath: "/settings/partners";
      preLoaderRoute: typeof AppSettingsPartnersRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/staff": {
      id: "/_app/settings/staff";
      path: "/staff";
      fullPath: "/settings/staff";
      preLoaderRoute: typeof AppSettingsStaffRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/stuck-visits": {
      id: "/_app/settings/stuck-visits";
      path: "/stuck-visits";
      fullPath: "/settings/stuck-visits";
      preLoaderRoute: typeof AppSettingsStuckVisitsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings_/account": {
      id: "/_app/settings_/account";
      path: "/settings/account";
      fullPath: "/settings/account";
      preLoaderRoute: typeof AppSettingsAccountRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/soon/$entry": {
      id: "/_app/soon/$entry";
      path: "/soon/$entry";
      fullPath: "/soon/$entry";
      preLoaderRoute: typeof AppSoonEntryRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/specialists/": {
      id: "/_app/specialists/";
      path: "/";
      fullPath: "/specialists/";
      preLoaderRoute: typeof AppSpecialistsIndexRouteImport;
      parentRoute: typeof AppSpecialistsRoute;
    };
    "/_app/specialists/$userId": {
      id: "/_app/specialists/$userId";
      path: "/$userId";
      fullPath: "/specialists/$userId";
      preLoaderRoute: typeof AppSpecialistsUserIdRouteImport;
      parentRoute: typeof AppSpecialistsRoute;
    };
    "/_app/specialists/blocked": {
      id: "/_app/specialists/blocked";
      path: "/blocked";
      fullPath: "/specialists/blocked";
      preLoaderRoute: typeof AppSpecialistsBlockedRouteImport;
      parentRoute: typeof AppSpecialistsRoute;
    };
    "/_app/specialists/ratings": {
      id: "/_app/specialists/ratings";
      path: "/ratings";
      fullPath: "/specialists/ratings";
      preLoaderRoute: typeof AppSpecialistsRatingsRouteImport;
      parentRoute: typeof AppSpecialistsRoute;
    };
    "/_app/specialists/support": {
      id: "/_app/specialists/support";
      path: "/support";
      fullPath: "/specialists/support";
      preLoaderRoute: typeof AppSpecialistsSupportRouteImport;
      parentRoute: typeof AppSpecialistsRoute;
    };
    "/_app/catalog/services/": {
      id: "/_app/catalog/services/";
      path: "/";
      fullPath: "/catalog/services/";
      preLoaderRoute: typeof AppCatalogServicesIndexRouteImport;
      parentRoute: typeof AppCatalogServicesRoute;
    };
    "/_app/catalog/services/$serviceId": {
      id: "/_app/catalog/services/$serviceId";
      path: "/$serviceId";
      fullPath: "/catalog/services/$serviceId";
      preLoaderRoute: typeof AppCatalogServicesServiceIdRouteImport;
      parentRoute: typeof AppCatalogServicesRoute;
    };
    "/_app/catalog/services/new": {
      id: "/_app/catalog/services/new";
      path: "/new";
      fullPath: "/catalog/services/new";
      preLoaderRoute: typeof AppCatalogServicesNewRouteImport;
      parentRoute: typeof AppCatalogServicesRoute;
    };
    "/_app/growth/campaigns/": {
      id: "/_app/growth/campaigns/";
      path: "/";
      fullPath: "/growth/campaigns/";
      preLoaderRoute: typeof AppGrowthCampaignsIndexRouteImport;
      parentRoute: typeof AppGrowthCampaignsRoute;
    };
    "/_app/growth/campaigns/$campaignId": {
      id: "/_app/growth/campaigns/$campaignId";
      path: "/$campaignId";
      fullPath: "/growth/campaigns/$campaignId";
      preLoaderRoute: typeof AppGrowthCampaignsCampaignIdRouteImport;
      parentRoute: typeof AppGrowthCampaignsRoute;
    };
    "/_app/growth/legal/": {
      id: "/_app/growth/legal/";
      path: "/";
      fullPath: "/growth/legal/";
      preLoaderRoute: typeof AppGrowthLegalIndexRouteImport;
      parentRoute: typeof AppGrowthLegalRoute;
    };
    "/_app/growth/legal/$versionId": {
      id: "/_app/growth/legal/$versionId";
      path: "/$versionId";
      fullPath: "/growth/legal/$versionId";
      preLoaderRoute: typeof AppGrowthLegalVersionIdRouteImport;
      parentRoute: typeof AppGrowthLegalRoute;
    };
    "/_app/growth/legal/new": {
      id: "/_app/growth/legal/new";
      path: "/new";
      fullPath: "/growth/legal/new";
      preLoaderRoute: typeof AppGrowthLegalNewRouteImport;
      parentRoute: typeof AppGrowthLegalRoute;
    };
    "/_app/growth/messages/": {
      id: "/_app/growth/messages/";
      path: "/";
      fullPath: "/growth/messages/";
      preLoaderRoute: typeof AppGrowthMessagesIndexRouteImport;
      parentRoute: typeof AppGrowthMessagesRoute;
    };
    "/_app/growth/news/": {
      id: "/_app/growth/news/";
      path: "/";
      fullPath: "/growth/news/";
      preLoaderRoute: typeof AppGrowthNewsIndexRouteImport;
      parentRoute: typeof AppGrowthNewsRoute;
    };
    "/_app/growth/news/$newsId": {
      id: "/_app/growth/news/$newsId";
      path: "/$newsId";
      fullPath: "/growth/news/$newsId";
      preLoaderRoute: typeof AppGrowthNewsNewsIdRouteImport;
      parentRoute: typeof AppGrowthNewsRoute;
    };
    "/_app/growth/news/new": {
      id: "/_app/growth/news/new";
      path: "/new";
      fullPath: "/growth/news/new";
      preLoaderRoute: typeof AppGrowthNewsNewRouteImport;
      parentRoute: typeof AppGrowthNewsRoute;
    };
    "/_app/growth/promo-codes/": {
      id: "/_app/growth/promo-codes/";
      path: "/";
      fullPath: "/growth/promo-codes/";
      preLoaderRoute: typeof AppGrowthPromoCodesIndexRouteImport;
      parentRoute: typeof AppGrowthPromoCodesRoute;
    };
    "/_app/growth/promo-codes/$promoId": {
      id: "/_app/growth/promo-codes/$promoId";
      path: "/$promoId";
      fullPath: "/growth/promo-codes/$promoId";
      preLoaderRoute: typeof AppGrowthPromoCodesPromoIdRouteImport;
      parentRoute: typeof AppGrowthPromoCodesRoute;
    };
    "/_app/growth/stories/": {
      id: "/_app/growth/stories/";
      path: "/";
      fullPath: "/growth/stories/";
      preLoaderRoute: typeof AppGrowthStoriesIndexRouteImport;
      parentRoute: typeof AppGrowthStoriesRoute;
    };
    "/_app/growth/stories/$storyId": {
      id: "/_app/growth/stories/$storyId";
      path: "/$storyId";
      fullPath: "/growth/stories/$storyId";
      preLoaderRoute: typeof AppGrowthStoriesStoryIdRouteImport;
      parentRoute: typeof AppGrowthStoriesRoute;
    };
    "/_app/growth/stories/new": {
      id: "/_app/growth/stories/new";
      path: "/new";
      fullPath: "/growth/stories/new";
      preLoaderRoute: typeof AppGrowthStoriesNewRouteImport;
      parentRoute: typeof AppGrowthStoriesRoute;
    };
    "/_app/money/adjustments/": {
      id: "/_app/money/adjustments/";
      path: "/";
      fullPath: "/money/adjustments/";
      preLoaderRoute: typeof AppMoneyAdjustmentsIndexRouteImport;
      parentRoute: typeof AppMoneyAdjustmentsRoute;
    };
    "/_app/money/adjustments/$adjustmentId": {
      id: "/_app/money/adjustments/$adjustmentId";
      path: "/$adjustmentId";
      fullPath: "/money/adjustments/$adjustmentId";
      preLoaderRoute: typeof AppMoneyAdjustmentsAdjustmentIdRouteImport;
      parentRoute: typeof AppMoneyAdjustmentsRoute;
    };
    "/_app/money/payouts/": {
      id: "/_app/money/payouts/";
      path: "/";
      fullPath: "/money/payouts/";
      preLoaderRoute: typeof AppMoneyPayoutsIndexRouteImport;
      parentRoute: typeof AppMoneyPayoutsRoute;
    };
    "/_app/money/payouts/$payoutId": {
      id: "/_app/money/payouts/$payoutId";
      path: "/$payoutId";
      fullPath: "/money/payouts/$payoutId";
      preLoaderRoute: typeof AppMoneyPayoutsPayoutIdRouteImport;
      parentRoute: typeof AppMoneyPayoutsRoute;
    };
    "/_app/money/specialists/$userId": {
      id: "/_app/money/specialists/$userId";
      path: "/specialists/$userId";
      fullPath: "/money/specialists/$userId";
      preLoaderRoute: typeof AppMoneySpecialistsUserIdRouteImport;
      parentRoute: typeof AppMoneyRoute;
    };
    "/_app/money/topups/": {
      id: "/_app/money/topups/";
      path: "/";
      fullPath: "/money/topups/";
      preLoaderRoute: typeof AppMoneyTopupsIndexRouteImport;
      parentRoute: typeof AppMoneyTopupsRoute;
    };
    "/_app/money/topups/$topupId": {
      id: "/_app/money/topups/$topupId";
      path: "/$topupId";
      fullPath: "/money/topups/$topupId";
      preLoaderRoute: typeof AppMoneyTopupsTopupIdRouteImport;
      parentRoute: typeof AppMoneyTopupsRoute;
    };
    "/_app/money/wallets/": {
      id: "/_app/money/wallets/";
      path: "/";
      fullPath: "/money/wallets/";
      preLoaderRoute: typeof AppMoneyWalletsIndexRouteImport;
      parentRoute: typeof AppMoneyWalletsRoute;
    };
    "/_app/money/wallets/$providerId": {
      id: "/_app/money/wallets/$providerId";
      path: "/$providerId";
      fullPath: "/money/wallets/$providerId";
      preLoaderRoute: typeof AppMoneyWalletsProviderIdRouteImport;
      parentRoute: typeof AppMoneyWalletsRoute;
    };
    "/_app/settings/staff/": {
      id: "/_app/settings/staff/";
      path: "/";
      fullPath: "/settings/staff/";
      preLoaderRoute: typeof AppSettingsStaffIndexRouteImport;
      parentRoute: typeof AppSettingsStaffRoute;
    };
    "/_app/settings/staff/$userId": {
      id: "/_app/settings/staff/$userId";
      path: "/$userId";
      fullPath: "/settings/staff/$userId";
      preLoaderRoute: typeof AppSettingsStaffUserIdRouteImport;
      parentRoute: typeof AppSettingsStaffRoute;
    };
    "/_app/specialists/support/": {
      id: "/_app/specialists/support/";
      path: "/";
      fullPath: "/specialists/support/";
      preLoaderRoute: typeof AppSpecialistsSupportIndexRouteImport;
      parentRoute: typeof AppSpecialistsSupportRoute;
    };
    "/_app/specialists/support/$threadId": {
      id: "/_app/specialists/support/$threadId";
      path: "/$threadId";
      fullPath: "/specialists/support/$threadId";
      preLoaderRoute: typeof AppSpecialistsSupportThreadIdRouteImport;
      parentRoute: typeof AppSpecialistsSupportRoute;
    };
    "/_app/growth/messages/people/$userId": {
      id: "/_app/growth/messages/people/$userId";
      path: "/people/$userId";
      fullPath: "/growth/messages/people/$userId";
      preLoaderRoute: typeof AppGrowthMessagesPeopleUserIdRouteImport;
      parentRoute: typeof AppGrowthMessagesRoute;
    };
    "/_app/specialists/support/to/$userId": {
      id: "/_app/specialists/support/to/$userId";
      path: "/to/$userId";
      fullPath: "/specialists/support/to/$userId";
      preLoaderRoute: typeof AppSpecialistsSupportToUserIdRouteImport;
      parentRoute: typeof AppSpecialistsSupportRoute;
    };
  }
}

interface AppCatalogServicesRouteChildren {
  AppCatalogServicesServiceIdRoute: typeof AppCatalogServicesServiceIdRoute;
  AppCatalogServicesNewRoute: typeof AppCatalogServicesNewRoute;
  AppCatalogServicesIndexRoute: typeof AppCatalogServicesIndexRoute;
}

const AppCatalogServicesRouteChildren: AppCatalogServicesRouteChildren = {
  AppCatalogServicesServiceIdRoute: AppCatalogServicesServiceIdRoute,
  AppCatalogServicesNewRoute: AppCatalogServicesNewRoute,
  AppCatalogServicesIndexRoute: AppCatalogServicesIndexRoute,
};

const AppCatalogServicesRouteWithChildren =
  AppCatalogServicesRoute._addFileChildren(AppCatalogServicesRouteChildren);

interface AppCatalogRouteChildren {
  AppCatalogAreasRoute: typeof AppCatalogAreasRoute;
  AppCatalogListsRoute: typeof AppCatalogListsRoute;
  AppCatalogPricesRoute: typeof AppCatalogPricesRoute;
  AppCatalogProfessionsRoute: typeof AppCatalogProfessionsRoute;
  AppCatalogServicesRoute: typeof AppCatalogServicesRouteWithChildren;
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute;
}

const AppCatalogRouteChildren: AppCatalogRouteChildren = {
  AppCatalogAreasRoute: AppCatalogAreasRoute,
  AppCatalogListsRoute: AppCatalogListsRoute,
  AppCatalogPricesRoute: AppCatalogPricesRoute,
  AppCatalogProfessionsRoute: AppCatalogProfessionsRoute,
  AppCatalogServicesRoute: AppCatalogServicesRouteWithChildren,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
};

const AppCatalogRouteWithChildren = AppCatalogRoute._addFileChildren(
  AppCatalogRouteChildren,
);

interface AppClientsRouteChildren {
  AppClientsUserIdRoute: typeof AppClientsUserIdRoute;
  AppClientsBlocksRoute: typeof AppClientsBlocksRoute;
  AppClientsIndexRoute: typeof AppClientsIndexRoute;
}

const AppClientsRouteChildren: AppClientsRouteChildren = {
  AppClientsUserIdRoute: AppClientsUserIdRoute,
  AppClientsBlocksRoute: AppClientsBlocksRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
};

const AppClientsRouteWithChildren = AppClientsRoute._addFileChildren(
  AppClientsRouteChildren,
);

interface AppGrowthCampaignsRouteChildren {
  AppGrowthCampaignsCampaignIdRoute: typeof AppGrowthCampaignsCampaignIdRoute;
  AppGrowthCampaignsIndexRoute: typeof AppGrowthCampaignsIndexRoute;
}

const AppGrowthCampaignsRouteChildren: AppGrowthCampaignsRouteChildren = {
  AppGrowthCampaignsCampaignIdRoute: AppGrowthCampaignsCampaignIdRoute,
  AppGrowthCampaignsIndexRoute: AppGrowthCampaignsIndexRoute,
};

const AppGrowthCampaignsRouteWithChildren =
  AppGrowthCampaignsRoute._addFileChildren(AppGrowthCampaignsRouteChildren);

interface AppGrowthLegalRouteChildren {
  AppGrowthLegalVersionIdRoute: typeof AppGrowthLegalVersionIdRoute;
  AppGrowthLegalNewRoute: typeof AppGrowthLegalNewRoute;
  AppGrowthLegalIndexRoute: typeof AppGrowthLegalIndexRoute;
}

const AppGrowthLegalRouteChildren: AppGrowthLegalRouteChildren = {
  AppGrowthLegalVersionIdRoute: AppGrowthLegalVersionIdRoute,
  AppGrowthLegalNewRoute: AppGrowthLegalNewRoute,
  AppGrowthLegalIndexRoute: AppGrowthLegalIndexRoute,
};

const AppGrowthLegalRouteWithChildren = AppGrowthLegalRoute._addFileChildren(
  AppGrowthLegalRouteChildren,
);

interface AppGrowthMessagesRouteChildren {
  AppGrowthMessagesIndexRoute: typeof AppGrowthMessagesIndexRoute;
  AppGrowthMessagesPeopleUserIdRoute: typeof AppGrowthMessagesPeopleUserIdRoute;
}

const AppGrowthMessagesRouteChildren: AppGrowthMessagesRouteChildren = {
  AppGrowthMessagesIndexRoute: AppGrowthMessagesIndexRoute,
  AppGrowthMessagesPeopleUserIdRoute: AppGrowthMessagesPeopleUserIdRoute,
};

const AppGrowthMessagesRouteWithChildren =
  AppGrowthMessagesRoute._addFileChildren(AppGrowthMessagesRouteChildren);

interface AppGrowthNewsRouteChildren {
  AppGrowthNewsNewsIdRoute: typeof AppGrowthNewsNewsIdRoute;
  AppGrowthNewsNewRoute: typeof AppGrowthNewsNewRoute;
  AppGrowthNewsIndexRoute: typeof AppGrowthNewsIndexRoute;
}

const AppGrowthNewsRouteChildren: AppGrowthNewsRouteChildren = {
  AppGrowthNewsNewsIdRoute: AppGrowthNewsNewsIdRoute,
  AppGrowthNewsNewRoute: AppGrowthNewsNewRoute,
  AppGrowthNewsIndexRoute: AppGrowthNewsIndexRoute,
};

const AppGrowthNewsRouteWithChildren = AppGrowthNewsRoute._addFileChildren(
  AppGrowthNewsRouteChildren,
);

interface AppGrowthPromoCodesRouteChildren {
  AppGrowthPromoCodesPromoIdRoute: typeof AppGrowthPromoCodesPromoIdRoute;
  AppGrowthPromoCodesIndexRoute: typeof AppGrowthPromoCodesIndexRoute;
}

const AppGrowthPromoCodesRouteChildren: AppGrowthPromoCodesRouteChildren = {
  AppGrowthPromoCodesPromoIdRoute: AppGrowthPromoCodesPromoIdRoute,
  AppGrowthPromoCodesIndexRoute: AppGrowthPromoCodesIndexRoute,
};

const AppGrowthPromoCodesRouteWithChildren =
  AppGrowthPromoCodesRoute._addFileChildren(AppGrowthPromoCodesRouteChildren);

interface AppGrowthStoriesRouteChildren {
  AppGrowthStoriesStoryIdRoute: typeof AppGrowthStoriesStoryIdRoute;
  AppGrowthStoriesNewRoute: typeof AppGrowthStoriesNewRoute;
  AppGrowthStoriesIndexRoute: typeof AppGrowthStoriesIndexRoute;
}

const AppGrowthStoriesRouteChildren: AppGrowthStoriesRouteChildren = {
  AppGrowthStoriesStoryIdRoute: AppGrowthStoriesStoryIdRoute,
  AppGrowthStoriesNewRoute: AppGrowthStoriesNewRoute,
  AppGrowthStoriesIndexRoute: AppGrowthStoriesIndexRoute,
};

const AppGrowthStoriesRouteWithChildren =
  AppGrowthStoriesRoute._addFileChildren(AppGrowthStoriesRouteChildren);

interface AppGrowthRouteChildren {
  AppGrowthCampaignsRoute: typeof AppGrowthCampaignsRouteWithChildren;
  AppGrowthLegalRoute: typeof AppGrowthLegalRouteWithChildren;
  AppGrowthMessagesRoute: typeof AppGrowthMessagesRouteWithChildren;
  AppGrowthNewsRoute: typeof AppGrowthNewsRouteWithChildren;
  AppGrowthPartnersRoute: typeof AppGrowthPartnersRoute;
  AppGrowthPromoCodesRoute: typeof AppGrowthPromoCodesRouteWithChildren;
  AppGrowthStoriesRoute: typeof AppGrowthStoriesRouteWithChildren;
  AppGrowthIndexRoute: typeof AppGrowthIndexRoute;
}

const AppGrowthRouteChildren: AppGrowthRouteChildren = {
  AppGrowthCampaignsRoute: AppGrowthCampaignsRouteWithChildren,
  AppGrowthLegalRoute: AppGrowthLegalRouteWithChildren,
  AppGrowthMessagesRoute: AppGrowthMessagesRouteWithChildren,
  AppGrowthNewsRoute: AppGrowthNewsRouteWithChildren,
  AppGrowthPartnersRoute: AppGrowthPartnersRoute,
  AppGrowthPromoCodesRoute: AppGrowthPromoCodesRouteWithChildren,
  AppGrowthStoriesRoute: AppGrowthStoriesRouteWithChildren,
  AppGrowthIndexRoute: AppGrowthIndexRoute,
};

const AppGrowthRouteWithChildren = AppGrowthRoute._addFileChildren(
  AppGrowthRouteChildren,
);

interface AppMoneyAdjustmentsRouteChildren {
  AppMoneyAdjustmentsAdjustmentIdRoute: typeof AppMoneyAdjustmentsAdjustmentIdRoute;
  AppMoneyAdjustmentsIndexRoute: typeof AppMoneyAdjustmentsIndexRoute;
}

const AppMoneyAdjustmentsRouteChildren: AppMoneyAdjustmentsRouteChildren = {
  AppMoneyAdjustmentsAdjustmentIdRoute: AppMoneyAdjustmentsAdjustmentIdRoute,
  AppMoneyAdjustmentsIndexRoute: AppMoneyAdjustmentsIndexRoute,
};

const AppMoneyAdjustmentsRouteWithChildren =
  AppMoneyAdjustmentsRoute._addFileChildren(AppMoneyAdjustmentsRouteChildren);

interface AppMoneyPayoutsRouteChildren {
  AppMoneyPayoutsPayoutIdRoute: typeof AppMoneyPayoutsPayoutIdRoute;
  AppMoneyPayoutsIndexRoute: typeof AppMoneyPayoutsIndexRoute;
}

const AppMoneyPayoutsRouteChildren: AppMoneyPayoutsRouteChildren = {
  AppMoneyPayoutsPayoutIdRoute: AppMoneyPayoutsPayoutIdRoute,
  AppMoneyPayoutsIndexRoute: AppMoneyPayoutsIndexRoute,
};

const AppMoneyPayoutsRouteWithChildren = AppMoneyPayoutsRoute._addFileChildren(
  AppMoneyPayoutsRouteChildren,
);

interface AppMoneyTopupsRouteChildren {
  AppMoneyTopupsTopupIdRoute: typeof AppMoneyTopupsTopupIdRoute;
  AppMoneyTopupsIndexRoute: typeof AppMoneyTopupsIndexRoute;
}

const AppMoneyTopupsRouteChildren: AppMoneyTopupsRouteChildren = {
  AppMoneyTopupsTopupIdRoute: AppMoneyTopupsTopupIdRoute,
  AppMoneyTopupsIndexRoute: AppMoneyTopupsIndexRoute,
};

const AppMoneyTopupsRouteWithChildren = AppMoneyTopupsRoute._addFileChildren(
  AppMoneyTopupsRouteChildren,
);

interface AppMoneyWalletsRouteChildren {
  AppMoneyWalletsProviderIdRoute: typeof AppMoneyWalletsProviderIdRoute;
  AppMoneyWalletsIndexRoute: typeof AppMoneyWalletsIndexRoute;
}

const AppMoneyWalletsRouteChildren: AppMoneyWalletsRouteChildren = {
  AppMoneyWalletsProviderIdRoute: AppMoneyWalletsProviderIdRoute,
  AppMoneyWalletsIndexRoute: AppMoneyWalletsIndexRoute,
};

const AppMoneyWalletsRouteWithChildren = AppMoneyWalletsRoute._addFileChildren(
  AppMoneyWalletsRouteChildren,
);

interface AppMoneyRouteChildren {
  AppMoneyAdjustmentsRoute: typeof AppMoneyAdjustmentsRouteWithChildren;
  AppMoneyBankCallsRoute: typeof AppMoneyBankCallsRoute;
  AppMoneyChannelsRoute: typeof AppMoneyChannelsRoute;
  AppMoneyLedgerRoute: typeof AppMoneyLedgerRoute;
  AppMoneyPayoutsRoute: typeof AppMoneyPayoutsRouteWithChildren;
  AppMoneyReportRoute: typeof AppMoneyReportRoute;
  AppMoneyTopupsRoute: typeof AppMoneyTopupsRouteWithChildren;
  AppMoneyWalletsRoute: typeof AppMoneyWalletsRouteWithChildren;
  AppMoneyIndexRoute: typeof AppMoneyIndexRoute;
  AppMoneySpecialistsUserIdRoute: typeof AppMoneySpecialistsUserIdRoute;
}

const AppMoneyRouteChildren: AppMoneyRouteChildren = {
  AppMoneyAdjustmentsRoute: AppMoneyAdjustmentsRouteWithChildren,
  AppMoneyBankCallsRoute: AppMoneyBankCallsRoute,
  AppMoneyChannelsRoute: AppMoneyChannelsRoute,
  AppMoneyLedgerRoute: AppMoneyLedgerRoute,
  AppMoneyPayoutsRoute: AppMoneyPayoutsRouteWithChildren,
  AppMoneyReportRoute: AppMoneyReportRoute,
  AppMoneyTopupsRoute: AppMoneyTopupsRouteWithChildren,
  AppMoneyWalletsRoute: AppMoneyWalletsRouteWithChildren,
  AppMoneyIndexRoute: AppMoneyIndexRoute,
  AppMoneySpecialistsUserIdRoute: AppMoneySpecialistsUserIdRoute,
};

const AppMoneyRouteWithChildren = AppMoneyRoute._addFileChildren(
  AppMoneyRouteChildren,
);

interface AppOrdersRouteChildren {
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute;
  AppOrdersCourseChecksRoute: typeof AppOrdersCourseChecksRoute;
  AppOrdersMapRoute: typeof AppOrdersMapRoute;
  AppOrdersNewRoute: typeof AppOrdersNewRoute;
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute;
}

const AppOrdersRouteChildren: AppOrdersRouteChildren = {
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrdersCourseChecksRoute: AppOrdersCourseChecksRoute,
  AppOrdersMapRoute: AppOrdersMapRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
};

const AppOrdersRouteWithChildren = AppOrdersRoute._addFileChildren(
  AppOrdersRouteChildren,
);

interface AppSettingsStaffRouteChildren {
  AppSettingsStaffUserIdRoute: typeof AppSettingsStaffUserIdRoute;
  AppSettingsStaffIndexRoute: typeof AppSettingsStaffIndexRoute;
}

const AppSettingsStaffRouteChildren: AppSettingsStaffRouteChildren = {
  AppSettingsStaffUserIdRoute: AppSettingsStaffUserIdRoute,
  AppSettingsStaffIndexRoute: AppSettingsStaffIndexRoute,
};

const AppSettingsStaffRouteWithChildren =
  AppSettingsStaffRoute._addFileChildren(AppSettingsStaffRouteChildren);

interface AppSettingsRouteChildren {
  AppSettingsActionsRoute: typeof AppSettingsActionsRoute;
  AppSettingsAppsRoute: typeof AppSettingsAppsRoute;
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute;
  AppSettingsCourseBonusRoute: typeof AppSettingsCourseBonusRoute;
  AppSettingsCoursePricesRoute: typeof AppSettingsCoursePricesRoute;
  AppSettingsDispatchRoute: typeof AppSettingsDispatchRoute;
  AppSettingsMarketsRoute: typeof AppSettingsMarketsRoute;
  AppSettingsPartnerDeliveriesRoute: typeof AppSettingsPartnerDeliveriesRoute;
  AppSettingsPartnersRoute: typeof AppSettingsPartnersRoute;
  AppSettingsStaffRoute: typeof AppSettingsStaffRouteWithChildren;
  AppSettingsStuckVisitsRoute: typeof AppSettingsStuckVisitsRoute;
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute;
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsActionsRoute: AppSettingsActionsRoute,
  AppSettingsAppsRoute: AppSettingsAppsRoute,
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsCourseBonusRoute: AppSettingsCourseBonusRoute,
  AppSettingsCoursePricesRoute: AppSettingsCoursePricesRoute,
  AppSettingsDispatchRoute: AppSettingsDispatchRoute,
  AppSettingsMarketsRoute: AppSettingsMarketsRoute,
  AppSettingsPartnerDeliveriesRoute: AppSettingsPartnerDeliveriesRoute,
  AppSettingsPartnersRoute: AppSettingsPartnersRoute,
  AppSettingsStaffRoute: AppSettingsStaffRouteWithChildren,
  AppSettingsStuckVisitsRoute: AppSettingsStuckVisitsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
};

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
);

interface AppSpecialistsSupportRouteChildren {
  AppSpecialistsSupportThreadIdRoute: typeof AppSpecialistsSupportThreadIdRoute;
  AppSpecialistsSupportIndexRoute: typeof AppSpecialistsSupportIndexRoute;
  AppSpecialistsSupportToUserIdRoute: typeof AppSpecialistsSupportToUserIdRoute;
}

const AppSpecialistsSupportRouteChildren: AppSpecialistsSupportRouteChildren = {
  AppSpecialistsSupportThreadIdRoute: AppSpecialistsSupportThreadIdRoute,
  AppSpecialistsSupportIndexRoute: AppSpecialistsSupportIndexRoute,
  AppSpecialistsSupportToUserIdRoute: AppSpecialistsSupportToUserIdRoute,
};

const AppSpecialistsSupportRouteWithChildren =
  AppSpecialistsSupportRoute._addFileChildren(
    AppSpecialistsSupportRouteChildren,
  );

interface AppSpecialistsRouteChildren {
  AppSpecialistsUserIdRoute: typeof AppSpecialistsUserIdRoute;
  AppSpecialistsBlockedRoute: typeof AppSpecialistsBlockedRoute;
  AppSpecialistsRatingsRoute: typeof AppSpecialistsRatingsRoute;
  AppSpecialistsSupportRoute: typeof AppSpecialistsSupportRouteWithChildren;
  AppSpecialistsIndexRoute: typeof AppSpecialistsIndexRoute;
}

const AppSpecialistsRouteChildren: AppSpecialistsRouteChildren = {
  AppSpecialistsUserIdRoute: AppSpecialistsUserIdRoute,
  AppSpecialistsBlockedRoute: AppSpecialistsBlockedRoute,
  AppSpecialistsRatingsRoute: AppSpecialistsRatingsRoute,
  AppSpecialistsSupportRoute: AppSpecialistsSupportRouteWithChildren,
  AppSpecialistsIndexRoute: AppSpecialistsIndexRoute,
};

const AppSpecialistsRouteWithChildren = AppSpecialistsRoute._addFileChildren(
  AppSpecialistsRouteChildren,
);

interface AppRouteChildren {
  AppCatalogRoute: typeof AppCatalogRouteWithChildren;
  AppClientsRoute: typeof AppClientsRouteWithChildren;
  AppGrowthRoute: typeof AppGrowthRouteWithChildren;
  AppMoneyRoute: typeof AppMoneyRouteWithChildren;
  AppNowRoute: typeof AppNowRoute;
  AppOrdersRoute: typeof AppOrdersRouteWithChildren;
  AppSettingsRoute: typeof AppSettingsRouteWithChildren;
  AppSpecialistsRoute: typeof AppSpecialistsRouteWithChildren;
  AppIndexRoute: typeof AppIndexRoute;
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute;
  AppSoonEntryRoute: typeof AppSoonEntryRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppCatalogRoute: AppCatalogRouteWithChildren,
  AppClientsRoute: AppClientsRouteWithChildren,
  AppGrowthRoute: AppGrowthRouteWithChildren,
  AppMoneyRoute: AppMoneyRouteWithChildren,
  AppNowRoute: AppNowRoute,
  AppOrdersRoute: AppOrdersRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSpecialistsRoute: AppSpecialistsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSoonEntryRoute: AppSoonEntryRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SignInRoute: SignInRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
